import { render } from "./Invoice.vue?vue&type=template&id=11ec6a23&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=ts"
export * from "./Invoice.vue?vue&type=script&lang=ts"

import "./Invoice.vue?vue&type=style&index=0&id=11ec6a23&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-11ec6a23"

export default script